function handleClick() {

    if (this.className == "fa fa-angle-down") {

        this.className = "fa fa-angle-up active";

        //this.innerHTML = "Close";

        this.setAttribute("aria-expanded", "true");

        this.parentNode.querySelector('ul').style.display = "block";

        var firstFocusableElement = this.parentNode.querySelector("ul").querySelector("a");

        firstFocusableElement.focus();

    } 
    else if (this.className == "fa fa-angle-right right") {

        this.className = "fa fa-angle-left right active";

        //this.innerHTML = "Close";

        this.setAttribute("aria-expanded", "true");

        this.parentNode.querySelector('ul').style.display = "block";

        var firstFocusableElement = this.parentNode.querySelector("ul").querySelector("a");

        firstFocusableElement.focus();

    }
    else if (this.className == "fa fa-angle-left right active") {

        this.className = "fa fa-angle-right right";

        //this.innerHTML = "Open";

        this.setAttribute("aria-expanded", "false");

        this.parentNode.querySelector('ul').style.display = "none";

    }
    else {

        this.className = "fa fa-angle-down";

        //this.innerHTML = "Open";

        this.setAttribute("aria-expanded", "false");

        this.parentNode.querySelector('ul').style.display = "none";

    }

}


function tabOut() {

        const nextElement = event.relatedTarget;

        const links = this.parentNode.parentNode.querySelectorAll("ul li a");

        inSameSubmenu = false;

        for (let i = 0; i < links.length - 1; i++) {
          if (nextElement.innerHTML == links[i].innerHTML) {
            inSameSubmenu = true;
          }
        }

        if (inSameSubmenu == false) {
          this.parentNode.parentNode.parentNode.querySelectorAll("button.fa.fa-angle-left.right.active")[0].className = "fa fa-angle-right right";
  
          //this.innerHTML = "Open";
  
          this.parentNode.parentNode.parentNode.querySelectorAll("button.fa.fa-angle-right.right")[0].setAttribute("aria-expanded", "false");
  
          this.parentNode.parentNode.parentNode.querySelector('ul').style.display = "none";
        }

}


function escClose() {
    const mainBtn = document.querySelectorAll(".fa.fa-angle-up.active");
    for (let i = 0; i < mainBtn.length; i++) {
      mainBtn[i].className = "fa fa-angle-down";
  
          //this.innerHTML = "Open";
  
          mainBtn[i].setAttribute("aria-expanded", "false");
  
          mainBtn[i].parentNode.querySelector('ul').style.display = "none";
    }
    const subBtns = document.querySelectorAll(".fa.fa-angle-left.right.active");
    for (let i = 0; i < subBtns.length; i++) {
      subBtns[i].className = "fa fa-angle-right right";
  
          //this.innerHTML = "Open";
  
          subBtns[i].setAttribute("aria-expanded", "false");
  
          subBtns[i].parentNode.querySelector('ul').style.display = "none";
    }
}

window.onload = function () {

  document.addEventListener("keyup", function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
    // Close the flyout menu
    escClose();
  }
  });

    const btns = document.querySelectorAll(".fa.fa-angle-down");

  for (let i = 0; i < btns.length; i++) {

    btns[i].addEventListener("click", handleClick);

    //btns[i].innerHTML = "Hello";

  }

  const subBtns = document.querySelectorAll(".fa.fa-angle-right");

  for (let i = 0; i < subBtns.length; i++) {

    subBtns[i].addEventListener("click", handleClick);

    //btns[i].innerHTML = "Hello";

  }

  const subMenus = document.querySelectorAll('ul.mn-sub li ul.mn-sub');

    for (let i = 0; i < subMenus.length; i++) {

        subMenuBtns = subMenus[i].querySelectorAll('li a');

        for (let j = 0; j < subMenuBtns.length; j++) {
            if (j == subMenuBtns.length - 1) {
                subMenuBtns[j].addEventListener("focusout", tabOut);
            }
        }

    }

}